// ─── Month names ─────────────────────────────────────────────────────────────
export const MONTH_NAMES = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

// ─── Column Definitions (full, all toggleable) ────────────────────────────────
export const COLS = [
  // Employee Info
  { key: "F_EmployeeMaster", label: "Employee *",      type: "select",  optKey: "EmployeeMaster", w: 180 },
  { key: "EmployeeName",     label: "Emp. Name",       type: "text",    w: 150, readOnly: true },
  { key: "FatherName",       label: "Father Name",     type: "text",    w: 130, readOnly: true },
  { key: "Department",       label: "Department",      type: "text",    w: 130, readOnly: true },
  { key: "JoinDate",         label: "Join Date",       type: "text",    w: 110, readOnly: true },
  { key: "BasicSalary",      label: "Basic Salary",    type: "number",  w: 100 },
  { key: "BasicTypeName",    label: "Basic Type",      type: "text",    w: 90,  readOnly: true },
  // Attendance
  { key: "MonthDays",        label: "Month Days",      type: "number",  w: 85 },
  { key: "WorkingDays",      label: "Working Days",    type: "number",  w: 90 },
  { key: "WorkingHours",     label: "Working Hrs",     type: "number",  w: 90, paramKey: "IsHourlyPayment" },
  { key: "WorkingMinutes",   label: "Working Mins",    type: "number",  w: 90, paramKey: "IsHourlyPayment" },
  { key: "LeaveWages",       label: "Leave Wages",     type: "number",  w: 85 },
  { key: "FestivalHoliday",  label: "Festival Hol.",   type: "number",  w: 90 },
  { key: "WeeklyHoliday",    label: "Weekly Hol.",     type: "number",  w: 85 },
  { key: "CL",               label: "CL",              type: "number",  w: 60 },
  { key: "ML",               label: "ML",              type: "number",  w: 60 },
  { key: "PaidDay",          label: "Paid Days",       type: "number",  w: 75, readOnly: true },
  { key: "OvertimeHours",    label: "OT Hours",        type: "number",  w: 80, paramKey: "IsOvertime" },
  // Earnings (all conditional)
  { key: "Arrear",           label: "Arrear",          type: "number",  w: 80, paramKey: "IsArrearApplicable" },
  { key: "AdvanceBonus",     label: "Adv. Bonus",      type: "number",  w: 85, paramKey: "IsAdvanceBonus" },
  { key: "ExtraPay",         label: "Extra Pay",       type: "number",  w: 80, paramKey: "IsExtraPay", labelParamKey: "ExtraPayCaption" },
  { key: "ExtraPay1",        label: "Extra Pay 1",     type: "number",  w: 85, paramKey: "IsExtraPay1", labelParamKey: "ExtraPay1Caption" },
  { key: "OverTime",         label: "OT Amount",       type: "number",  w: 85, readOnly: true, paramKey: "IsOvertime" },
  
  // 10 Allowance columns
  { key: "OriginalAllowance1", label: "Allowance 1", type: "number", w: 85, isAllowance: true, idx: 1 },
  { key: "OriginalAllowance2", label: "Allowance 2", type: "number", w: 85, isAllowance: true, idx: 2 },
  { key: "OriginalAllowance3", label: "Allowance 3", type: "number", w: 85, isAllowance: true, idx: 3 },
  { key: "OriginalAllowance4", label: "Allowance 4", type: "number", w: 85, isAllowance: true, idx: 4 },
  { key: "OriginalAllowance5", label: "Allowance 5", type: "number", w: 85, isAllowance: true, idx: 5 },
  { key: "OriginalAllowance6", label: "Allowance 6", type: "number", w: 85, isAllowance: true, idx: 6 },
  { key: "OriginalAllowance7", label: "Allowance 7", type: "number", w: 85, isAllowance: true, idx: 7 },
  { key: "OriginalAllowance8", label: "Allowance 8", type: "number", w: 85, isAllowance: true, idx: 8 },
  { key: "OriginalAllowance9", label: "Allowance 9", type: "number", w: 85, isAllowance: true, idx: 9 },
  { key: "OriginalAllowance10", label: "Allowance 10", type: "number", w: 85, isAllowance: true, idx: 10 },

  { key: "TotalAllowances",  label: "Allowances",      type: "number",  w: 90, readOnly: true },
  { key: "TotalDeductions",  label: "Ded.(Other)",     type: "number",  w: 90, readOnly: true },
  // Deductions (conditional)
  { key: "Recovery",         label: "Recovery",        type: "number",  w: 80, paramKey: "IsRecovery" },
  { key: "Advance",          label: "Advance",         type: "number",  w: 80, paramKey: "IsAdvance" },
  { key: "TDS",              label: "TDS",             type: "number",  w: 70, paramKey: "IsTDS" },

  // 10 Deduction columns
  { key: "OriginalDeduction1", label: "Deduction 1", type: "number", w: 85, isDeduction: true, idx: 1 },
  { key: "OriginalDeduction2", label: "Deduction 2", type: "number", w: 85, isDeduction: true, idx: 2 },
  { key: "OriginalDeduction3", label: "Deduction 3", type: "number", w: 85, isDeduction: true, idx: 3 },
  { key: "OriginalDeduction4", label: "Deduction 4", type: "number", w: 85, isDeduction: true, idx: 4 },
  { key: "OriginalDeduction5", label: "Deduction 5", type: "number", w: 85, isDeduction: true, idx: 5 },
  { key: "OriginalDeduction6", label: "Deduction 6", type: "number", w: 85, isDeduction: true, idx: 6 },
  { key: "OriginalDeduction7", label: "Deduction 7", type: "number", w: 85, isDeduction: true, idx: 7 },
  { key: "OriginalDeduction8", label: "Deduction 8", type: "number", w: 85, isDeduction: true, idx: 8 },
  { key: "OriginalDeduction9", label: "Deduction 9", type: "number", w: 85, isDeduction: true, idx: 9 },
  { key: "OriginalDeduction10", label: "Deduction 10", type: "number", w: 85, isDeduction: true, idx: 10 },

  { key: "PFRefund",         label: "PF Refund",       type: "number",  w: 80, paramKey: "IsPFAdvRefund" },
  { key: "ArrearPF",         label: "Arrear PF",       type: "number",  w: 80, paramKey: "IsPF" },
  { key: "ArrERPF",          label: "Arr.ERPF",        type: "number",  w: 80, paramKey: "IsPF" },
  { key: "ArrPens",          label: "Arr.Pens.",       type: "number",  w: 80, paramKey: "IsPF" },
  { key: "PFReason",         label: "PF Reason",       type: "text",    w: 120, paramKey: "IsPF" },
  { key: "PFLast",           label: "PF Last",         type: "text",    w: 80,  paramKey: "IsPF" },
  // PF / ESI (conditional)
  { key: "PF",               label: "PF",              type: "number",  w: 75,  readOnly: true, paramKey: "IsPF" },
  { key: "EmplrPF",          label: "Emplr PF",        type: "number",  w: 80,  readOnly: true, paramKey: "IsPF" },
  { key: "Pension",          label: "Pension",         type: "number",  w: 80,  readOnly: true, paramKey: "IsPF" },

  { key: "AC22",             label: "AC22",            type: "number",  w: 70,  readOnly: true, paramKey: "IsPF" },
  { key: "ESI",              label: "ESI",             type: "number",  w: 70,  readOnly: true, paramKey: "IsESI" },
  { key: "EmplrESI",         label: "Emplr ESI",       type: "number",  w: 80,  readOnly: true, paramKey: "IsESI" },
  { key: "Bonus",            label: "Bonus",           type: "number",  w: 75,  readOnly: true, paramKey: "IsBonusParameter" },
  { key: "Gratuity",         label: "Gratuity",        type: "number",  w: 80,  readOnly: true, paramKey: "IsGratuity" },
  // Leave Balance
  { key: "PL_Bal",           label: "PL Bal",          type: "number",  w: 65 },
  { key: "CL_Bal",           label: "CL Bal",          type: "number",  w: 65 },
  { key: "ML_Bal",           label: "ML Bal",          type: "number",  w: 65 },
  { key: "PL_Enjoy",         label: "PL Enjoy",        type: "number",  w: 70 },
  { key: "CL_Enjoy",         label: "CL Enjoy",        type: "number",  w: 70 },
  { key: "ML_Enjoy",         label: "ML Enjoy",        type: "number",  w: 70 },
  // Leave Dates
  { key: "LeaveWithWages",   label: "Leave w/Wages",   type: "number",  w: 90 },
  { key: "LeaveFrom1",       label: "Lv.From1",        type: "number",  w: 75 },
  { key: "LeaveTo1",         label: "Lv.To1",          type: "number",  w: 70 },
  { key: "LeaveFrom2",       label: "Lv.From2",        type: "number",  w: 75 },
  { key: "LeaveTo2",         label: "Lv.To2",          type: "number",  w: 70 },
  { key: "LeaveFrom3",       label: "Lv.From3",        type: "number",  w: 75 },
  { key: "LeaveTo3",         label: "Lv.To3",          type: "number",  w: 70 },
  // Absent
  { key: "AbsentDays",       label: "Absent Days",     type: "number",  w: 80 },
  { key: "AbsentFrom1",      label: "Ab.From1",        type: "number",  w: 75 },
  { key: "AbsentTo1",        label: "Ab.To1",          type: "number",  w: 70 },
  { key: "AbsentFrom2",      label: "Ab.From2",        type: "number",  w: 75 },
  { key: "AbsentTo2",        label: "Ab.To2",          type: "number",  w: 70 },
  { key: "AbsentFrom3",      label: "Ab.From3",        type: "number",  w: 75 },
  { key: "AbsentTo3",        label: "Ab.To3",          type: "number",  w: 70 },
  // Summary
  { key: "Wages",            label: "Wages",           type: "number",  w: 85,  readOnly: true },
  { key: "GrossAmount",      label: "Gross Amt",       type: "number",  w: 95,  readOnly: true },
  { key: "TotalDeduction",   label: "Total Deduct.",   type: "number",  w: 100, readOnly: true },
  { key: "NetAmount",        label: "Net Amount",      type: "number",  w: 95,  readOnly: true }
];

// Group bands for header row
export const COL_GROUPS = [
  { label: "Employee Info",  startKey: "F_EmployeeMaster", endKey: "BasicTypeName",   color: "#1565c0" },
  { label: "Attendance",     startKey: "MonthDays",        endKey: "OvertimeHours",   color: "#1b5e20" },
  { label: "Earnings",       startKey: "Arrear",           endKey: "TotalDeductions", color: "#e65100" },
  { label: "Deductions",     startKey: "Recovery",         endKey: "PFLast",          color: "#b71c1c" },
  { label: "PF / ESI",       startKey: "PF",               endKey: "Gratuity",        color: "#006064" },
  { label: "Leave Balance",  startKey: "PL_Bal",           endKey: "ML_Enjoy",        color: "#33691e" },
  { label: "Leave Dates",    startKey: "LeaveWithWages",   endKey: "LeaveTo3",        color: "#01579b" },
  { label: "Absent",         startKey: "AbsentDays",       endKey: "AbsentTo3",       color: "#880e4f" },
  { label: "Summary",        startKey: "Wages",            endKey: "NetAmount",       color: "#37474f" },
];

export const visibleKeys = new Set(COLS.map(c => c.key));

// ─── Numeric helper ───────────────────────────────────────────────────────────
export const n = (v) => parseFloat(v) || 0;

export const formatDateForSave = (dateValue) => {
  if (!dateValue) return "";
  if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }
  const dateObj = new Date(dateValue);
  if (isNaN(dateObj.getTime())) return "";
  return dateObj.toISOString().split('T')[0];
};

// ─── Empty row factory ────────────────────────────────────────────────────────
export const emptyRow = () => {
  const base = {
    Id: 0,
    F_EmployeeMaster: "", EmployeeName: "", FatherName: "", Department: "", JoinDate: "",
    BasicSalary: 0, BasicTypeName: "",
    MonthDays: 31,
    WorkingDays: 0, WorkingHours: 0, WorkingMinutes: 0, LeaveWages: 0, FestivalHoliday: 0,
    WeeklyHoliday: 0, CL: 0, ML: 0, PaidDay: 0, OvertimeHours: 0,
    Arrear: 0, AdvanceBonus: 0, ExtraPay: 0, ExtraPay1: 0, OverTime: 0,
    TotalAllowances: 0, TotalDeductions: 0,
    Recovery: 0, Advance: 0, TDS: 0, PFRefund: 0, ArrearPF: 0, ArrERPF: 0, ArrPens: 0,
    PFReason: "", PFLast: "",
    PF: 0, EmplrPF: 0, Pension: 0, AdminCharges: 0, AC21: 0, AC22: 0,
    ESI: 0, EmplrESI: 0, Bonus: 0, Gratuity: 0,
    PFApplicable: false, ESIApplicable: false,
    PL_Bal: 0, CL_Bal: 0, ML_Bal: 0, PL_Enjoy: 0, CL_Enjoy: 0, ML_Enjoy: 0,
    LeaveWithWages: 0,
    LeaveFrom1: 0, LeaveTo1: 0, LeaveFrom2: 0, LeaveTo2: 0, LeaveFrom3: 0, LeaveTo3: 0,
    AbsentDays: 0, AbsentFrom1: 0, AbsentTo1: 0, AbsentFrom2: 0, AbsentTo2: 0,
    AbsentFrom3: 0, AbsentTo3: 0,
    Wages: 0, GrossAmount: 0, TotalDeduction: 0, NetAmount: 0,
  };
  for (let i = 1; i <= 10; i++) {
    base[`Allowance${i}Name`] = "";
    base[`OriginalAllowance${i}`] = 0;
    base[`CalculatedAllowance${i}`] = 0;
    base[`Deduction${i}Name`] = "";
    base[`OriginalDeduction${i}`] = 0;
    base[`CalculatedDeduction${i}`] = 0;
  }
  return base;
};

// Pick latest allowance entry per master whose EffectiveFrom <= payroll period
export const getEffectiveAllowances = (allowanceList, selectedMonth, selectedYear) => {
  const byMaster = {};
  const periodMonth = MONTH_NAMES.indexOf(selectedMonth);
  const periodYear  = parseInt(selectedYear) || new Date().getFullYear();
  (allowanceList || []).forEach(a => {
    const eff = new Date(a.EffectiveFrom);
    const isEffective = (eff.getFullYear() < periodYear) ||
      (eff.getFullYear() === periodYear && eff.getMonth() <= periodMonth);
    if (isEffective) {
      const key = a.F_AllowanceMaster;
      if (!byMaster[key] || new Date(byMaster[key].EffectiveFrom) < eff) byMaster[key] = a;
    }
  });
  return Object.values(byMaster);
};

export const computeSingleAllowance = (a, monthDays, paidDays, basicSalary) => {
  if (!a.IsApplicable) return 0;
  let base = n(a.Amount);
  if (a.Calculation === "PERCENTAGE") base = (base / 100) * n(basicSalary);
  else if (a.Calculation === "DAILY") return Math.round(base * paidDays * 100) / 100;
  if (a.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
  return Math.round(base * 100) / 100;
};

export const computeAllowancesTotal = (allowanceList, monthDays, paidDays, basicSalary, selectedMonth, selectedYear) => {
  const effective = getEffectiveAllowances(allowanceList, selectedMonth, selectedYear);
  let total = 0;
  effective.forEach(a => {
    if (!a.IsApplicable) return;
    let base = parseFloat(a.Amount) || 0;
    if (a.Calculation === 'PERCENTAGE') {
      base = (base / 100) * (parseFloat(basicSalary) || 0);
    } else if (a.Calculation === 'DAILY') {
      total += base * paidDays;
      return;
    }
    if (a.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
    total += base;
  });
  return Math.round(total * 100) / 100;
};

export const computePFAllowancesAmount = (allowanceList, monthDays, paidDays, basicSalary, selectedMonth, selectedYear) => {
  const effective = getEffectiveAllowances(allowanceList, selectedMonth, selectedYear);
  let total = 0;
  effective.forEach(a => {
    if (!a.IsApplicable || !a.IsPFApply) return;
    let base = parseFloat(a.Amount) || 0;
    if (a.Calculation === 'PERCENTAGE') {
      base = (base / 100) * (parseFloat(basicSalary) || 0);
    } else if (a.Calculation === 'DAILY') {
      total += base * paidDays;
      return;
    }
    if (a.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
    total += base;
  });
  return Math.round(total * 100) / 100;
};

export const computeESIAllowancesAmount = (allowanceList, monthDays, paidDays, basicSalary, selectedMonth, selectedYear) => {
  const effective = getEffectiveAllowances(allowanceList, selectedMonth, selectedYear);
  let total = 0;
  effective.forEach(a => {
    if (!a.IsApplicable || !a.IsESIApply) return;
    let base = parseFloat(a.Amount) || 0;
    if (a.Calculation === 'PERCENTAGE') {
      base = (base / 100) * (parseFloat(basicSalary) || 0);
    } else if (a.Calculation === 'DAILY') {
      total += base * paidDays;
      return;
    }
    if (a.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
    total += base;
  });
  return Math.round(total * 100) / 100;
};

// Pick latest deduction entry per master whose EffectiveFrom <= payroll period
export const getEffectiveDeductions = (deductionList, selectedMonth, selectedYear) => {
  const byMaster = {};
  const periodMonth = MONTH_NAMES.indexOf(selectedMonth);
  const periodYear  = parseInt(selectedYear) || new Date().getFullYear();
  (deductionList || []).forEach(d => {
    const eff = new Date(d.EffectiveFrom);
    const isEffective = (eff.getFullYear() < periodYear) ||
      (eff.getFullYear() === periodYear && eff.getMonth() <= periodMonth);
    if (isEffective) {
      const key = d.F_DeductionMaster;
      if (!byMaster[key] || new Date(byMaster[key].EffectiveFrom) < eff) byMaster[key] = d;
    }
  });
  return Object.values(byMaster);
};

export const computeSingleDeduction = (d, monthDays, paidDays, basicSalary) => {
  if (!d.IsApplicable) return 0;
  let base = n(d.Amount);
  if (d.Calculation === "PERCENTAGE") base = (base / 100) * n(basicSalary);
  else if (d.Calculation === "DAILY") return Math.round(base * paidDays * 100) / 100;
  if (d.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
  return Math.round(base * 100) / 100;
};

export const computeDeductionsTotal = (deductionList, monthDays, paidDays, basicSalary, selectedMonth, selectedYear) => {
  const effective = getEffectiveDeductions(deductionList, selectedMonth, selectedYear);
  let total = 0;
  effective.forEach(d => {
    if (!d.IsApplicable) return;
    let base = parseFloat(d.Amount) || 0;
    if (d.Calculation === 'PERCENTAGE') {
      base = (base / 100) * (parseFloat(basicSalary) || 0);
    } else if (d.Calculation === 'DAILY') {
      total += base * paidDays;
      return;
    }
    if (d.IsWorkingDaysApply && monthDays > 0) base = (base / monthDays) * paidDays;
    total += base;
  });
  return Math.round(total * 100) / 100;
};

// Pick latest SalaryJson entry whose EffectiveDate <= selected month/year
export const getEffectiveSalary = (salaryList, selectedMonth, selectedYear) => {
  const periodMonth = MONTH_NAMES.indexOf(selectedMonth);
  const periodYear  = parseInt(selectedYear) || new Date().getFullYear();
  const eligible = (salaryList || []).filter(s => {
    const eff = new Date(s.EffectiveDate);
    return (eff.getFullYear() < periodYear) ||
      (eff.getFullYear() === periodYear && eff.getMonth() <= periodMonth);
  });
  const pool = eligible.length > 0 ? eligible : (salaryList || []);
  return pool.reduce((best, s) => !best || new Date(s.EffectiveDate) > new Date(best.EffectiveDate) ? s : best, null);
};

// Working days based on payrollParams
export const computeWorkingDays = (monthDays, payrollParams) => {
  if (!payrollParams) return 26;
  if (payrollParams.Is26DaysWorking) return 26;
  if (payrollParams.IsSundayInclude) return monthDays;
  return monthDays - Math.floor(monthDays / 7);
};

// Basic salary from salary entry + BasicType
export const computeBasic = (salaryEntry, workingDays, payrollParams) => {
  if (!salaryEntry) return 0;
  const raw  = parseFloat(salaryEntry.BasicSalary) || 0;
  const type = salaryEntry.F_BasicTypeMaster;
  if (type === 1) return raw;
  if (type === 2) return Math.round(raw * workingDays * 100) / 100;
  if (type === 3) return Math.round(raw * workingDays * 8 * 100) / 100;
  return raw;
};

// Wages from paid days + BasicType
export const computeWages = (salaryEntry, paidDays, monthDays, workingHours, workingMinutes, payrollParams) => {
  if (!salaryEntry) return 0;
  const basicSalary = parseFloat(salaryEntry.BasicSalary) || 0;
  const type = salaryEntry.F_BasicTypeMaster;
  if (type === 1) { return monthDays === 0 ? 0 : Math.round((basicSalary * paidDays / monthDays) * 100) / 100; }
  if (type === 2) { return Math.round(basicSalary * paidDays * 100) / 100; }
  if (type === 3) {
    const totalHours = (parseInt(workingHours) || 0) + ((parseInt(workingMinutes) || 0) / 60);
    return Math.round(basicSalary * totalHours * paidDays * 100) / 100;
  }
  return basicSalary;
};

// Overtime using BasicType + payrollParams flags
export const computeOvertime = (salaryEntry, otHours, monthDays, payrollParams) => {
  if (!payrollParams || !payrollParams.IsOvertime) return 0;
  if (!salaryEntry) return 0;
  const hours = parseFloat(otHours) || 0;
  if (hours <= 0) return 0;
  const basicSalary = parseFloat(salaryEntry.BasicSalary) || 0;
  if (basicSalary <= 0) return 0;
  const type       = salaryEntry.F_BasicTypeMaster;
  const divisor    = payrollParams.IsOTOn26Days ? 26 : (monthDays || 26);
  const multiplier = payrollParams.IsDoubleOT ? 2 : 1;
  let hourlyRate = 0;
  if (type === 2) hourlyRate = basicSalary / 8;
  else if (type === 3) hourlyRate = basicSalary;
  else hourlyRate = basicSalary / divisor / 8;
  return Math.round(hourlyRate * multiplier * hours * 100) / 100;
};

// PF: employee (PF), employer-A1 (EmplrPF), pension (Pension), employer-only charges (AdminCharges, AC21, AC22)
export const computePF = (pfBaseWages, pf, pfAllowancesAmount = 0) => {
  if (!pf) return { PF: 0, EmplrPF: 0, Pension: 0, AdminCharges: 0, AC21: 0, AC22: 0 };
  const rate        = parseFloat(pf.Rate)               || 0;
  const erRate      = parseFloat(pf.EmployerRate)       || 0;
  const penRate     = parseFloat(pf.PensionRate)        || 0;
  const maxPen      = parseFloat(pf.MaxPensionAmt)      || 0;
  const maxWagesPF  = parseFloat(pf.MaxWagesForPF)      || 0;
  const maxWagesPen = parseFloat(pf.MaxWagesForPension) || 0;
  const pfBase      = pfBaseWages + (pfAllowancesAmount || 0);
  const pfWages     = maxWagesPF  > 0 ? Math.min(pfBase, maxWagesPF)  : pfBase;
  const penWages    = maxWagesPen > 0 ? Math.min(pfBaseWages, maxWagesPen) : pfBaseWages;
  const empPF       = Math.round(pfWages  * rate                          / 100);
  let   pension     = Math.round(penWages * penRate                       / 100);
  if (maxPen > 0) pension = Math.min(pension, maxPen);
  const emplrPF     = Math.round(pfWages  * Math.max(erRate - penRate, 0) / 100);
  // Admin Charges (employer only)
  const adminRate  = parseFloat(pf.AdminCharges)          || 0;
  const adminMin   = parseFloat(pf.AdminChargesMinAmount) || 0;
  const AdminCharges = Math.max(Math.round(pfWages * adminRate / 100 * 100) / 100, adminMin);
  // AC21
  const ac21Rate = (parseFloat(pf.AC21WithGroupIns) || 0) > 0 ? parseFloat(pf.AC21WithGroupIns) : (parseFloat(pf.AC21WithoutGroupIns) || 0);
  const ac21Min  = parseFloat(pf.AC21WithGroupInsMinAmt) || 0;
  const AC21     = Math.max(Math.round(pfWages * ac21Rate / 100 * 100) / 100, ac21Min);
  // AC22
  const ac22Rate = (parseFloat(pf.AC22WithGroupIns) || 0) > 0 ? parseFloat(pf.AC22WithGroupIns) : (parseFloat(pf.AC22WithoutGroupIns) || 0);
  const ac22Min  = parseFloat(pf.AC22WithGroupInsMinAmt) || 0;
  const AC22     = ac22Rate > 0 ? Math.max(Math.round(pfWages * ac22Rate / 100 * 100) / 100, ac22Min) : 0;
  return { PF: empPF, EmplrPF: emplrPF, Pension: pension, AdminCharges, AC21, AC22 };
};

// ESI: employee (ESI) + employer (EmplrESI)
export const computeESI = (grossWages, esi, pparms) => {
  if (!esi) return { ESI: 0, EmplrESI: 0 };
  const wagesLimit     = n(esi.WagesLimit);
  const empRate        = n(esi.EmployeeContribution);
  const erRate         = n(esi.EmployerContribution);
  const exemptionLimit = n(esi.EmployeeExemptionLimit);
  const roundOn        = !!(esi?.RoundedOn);
  if (wagesLimit > 0 && grossWages > wagesLimit) return { ESI: 0, EmplrESI: 0 };
  let empESI   = grossWages * empRate / 100;
  let emplrESI = grossWages * erRate  / 100;
  if (exemptionLimit > 0 && grossWages <= exemptionLimit) empESI = 0;
  if (roundOn) { empESI = Math.round(empESI); emplrESI = Math.round(emplrESI); }
  else { empESI = Math.round(empESI * 100) / 100; emplrESI = Math.round(emplrESI * 100) / 100; }
  return { ESI: empESI, EmplrESI: emplrESI };
};

// Bonus
export const computeBonus = (wages, bonus, paidDays) => {
  if (!bonus) return 0;
  const rate     = parseFloat(bonus.BonusRate)        || 0;
  const maxWages = parseFloat(bonus.MaximumWages)     || 0;
  const maxBonus = parseFloat(bonus.MaximumBonus)     || 0;
  const minBonus = parseFloat(bonus.MinimumBonus)     || 0;
  const minDays  = parseFloat(bonus.MinimumBonusDays) || 0;
  if (minDays > 0 && paidDays < minDays) return 0;
  const bonusWages = maxWages > 0 ? Math.min(wages, maxWages) : wages;
  let bonusAmount  = bonusWages * rate / 100;
  if (maxBonus > 0) bonusAmount = Math.min(bonusAmount, maxBonus);
  if (minBonus > 0) bonusAmount = Math.max(bonusAmount, minBonus);
  return Math.round(bonusAmount * 100) / 100;
};

// Gratuity
export const computeGratuity = (basicSalary, gratuity, yearsOfService = 1) => {
  if (!gratuity) return 0;
  const rate = parseFloat(gratuity.Rate) || 0;
  if (rate > 0) return Math.round(basicSalary * rate / 100 * 100) / 100;
  return Math.round(basicSalary * 4.81 / 100 * 100) / 100;
};

export const reconstructAllowancesFromRecord = (record, allowanceMasterList) => {
  const list = [];
  for (let i = 1; i <= 10; i++) {
    const name = record[`Allowance${i}Name`];
    const amt = parseFloat(record[`OriginalAllowance${i}`]) || 0;
    if (name) {
      const master = allowanceMasterList.find(m => m.Name === name);
      if (master) {
        list.push({
          F_AllowanceMaster: master.Id,
          Amount: amt,
          IsApplicable: true,
        });
      }
    }
  }
  return list;
};

export const reconstructDeductionsFromRecord = (record, deductionMasterList) => {
  const list = [];
  for (let i = 1; i <= 10; i++) {
    const name = record[`Deduction${i}Name`];
    const amt = parseFloat(record[`OriginalDeduction${i}`]) || 0;
    if (name) {
      const master = deductionMasterList.find(m => m.Name === name);
      if (master) {
        list.push({
          F_DeductionMaster: master.Id,
          Amount: amt,
          IsApplicable: true,
        });
      }
    }
  }
  return list;
};

// ─── Full row recompute ───────────────────────────────────────────────────────
export const recomputeRow = (row, allowances, deductions, pfRate, esiRate, bonusRate, gratuityRate, payrollParams, salaryEntry, selectedMonth, selectedYear, allowanceMasterList = [], deductionMasterList = []) => {
  const monthDays    = n(row.MonthDays) || 31;
  const paidDays     = Math.min(monthDays, n(row.WorkingDays) + n(row.LeaveWages) + n(row.FestivalHoliday) + n(row.WeeklyHoliday) + n(row.CL) + n(row.ML));
  const workingDays  = computeWorkingDays(monthDays, payrollParams);
  const baseSalary   = n(row.BasicSalary) || computeBasic(salaryEntry, workingDays, payrollParams);
  const wages        = computeWages({ BasicSalary: n(row.BasicSalary), F_BasicTypeMaster: salaryEntry?.F_BasicTypeMaster || 1 }, paidDays, monthDays, n(row.WorkingHours), n(row.WorkingMinutes), payrollParams);
  const otAmount     = computeOvertime(salaryEntry, n(row.OvertimeHours), monthDays, payrollParams);
  const totalAl      = computeAllowancesTotal(allowances, monthDays, paidDays, baseSalary, selectedMonth, selectedYear);
  const totalDed     = computeDeductionsTotal(deductions, monthDays, paidDays, baseSalary, selectedMonth, selectedYear);
  const pfAlAmt      = computePFAllowancesAmount(allowances, monthDays, paidDays, baseSalary, selectedMonth, selectedYear);
  const esiAlAmt     = computeESIAllowancesAmount(allowances, monthDays, paidDays, baseSalary, selectedMonth, selectedYear);
  const bonus        = computeBonus(wages, bonusRate, paidDays);
  const gratuity     = computeGratuity(baseSalary, gratuityRate, 1);

  const pfBase = wages
    + (payrollParams?.IsPFOnOT       ? otAmount        : 0)
    + (payrollParams?.IsPFOnArrear   ? n(row.Arrear)   : 0)
    + (payrollParams?.IsPFOnExtraPay  ? n(row.ExtraPay)  : 0)
    + (payrollParams?.IsPFOnExtraPay1 ? n(row.ExtraPay1) : 0);

  const esiBase = wages
    + esiAlAmt
    + (payrollParams?.IsESIOnOT       ? otAmount        : 0)
    + (payrollParams?.IsESIOnArrear   ? n(row.Arrear)   : 0)
    + (payrollParams?.IsESIOnExtraPay  ? n(row.ExtraPay)  : 0)
    + (payrollParams?.IsESIOnExtraPay1 ? n(row.ExtraPay1) : 0)
    + bonus;

  const gross = wages + n(row.ExtraPay) + n(row.ExtraPay1) + n(row.AdvanceBonus) + n(row.Arrear) + n(row.LeaveWages) + otAmount + totalAl + bonus;

  const { PF, EmplrPF, Pension, AdminCharges, AC21, AC22 } = row.PFApplicable
    ? computePF(pfBase, pfRate, pfAlAmt)
    : { PF: 0, EmplrPF: 0, Pension: 0, AdminCharges: 0, AC21: 0, AC22: 0 };

  const { ESI, EmplrESI } = row.ESIApplicable
    ? computeESI(esiBase, esiRate, payrollParams)
    : { ESI: 0, EmplrESI: 0 };

  const deduct = PF + ESI + n(row.Recovery) + n(row.TDS) + totalDed;

  const updatedRow = {
    ...row,
    PaidDay: paidDays,
    Wages: wages,
    OverTime: otAmount,
    TotalAllowances: totalAl,
    TotalDeductions: totalDed,
    GrossAmount:   Math.round(gross  * 100) / 100,
    PF, EmplrPF, Pension, AdminCharges, AC21, AC22,
    ESI, EmplrESI,
    Bonus:    bonus,
    Gratuity: gratuity,
    TotalDeduction: Math.round(deduct * 100) / 100,
    NetAmount: Math.round((gross - deduct + n(row.PFRefund)) * 100) / 100,
  };

  const effectiveAllowances = getEffectiveAllowances(allowances, selectedMonth, selectedYear);
  for (let i = 0; i < 10; i++) {
    const a = effectiveAllowances[i];
    if (a) {
      const computed = computeSingleAllowance(a, monthDays, paidDays, baseSalary);
      updatedRow[`Allowance${i+1}Name`] = allowanceMasterList.find(m => String(m.Id) === String(a.F_AllowanceMaster))?.Name || `Allow_${a.F_AllowanceMaster}`;
      updatedRow[`OriginalAllowance${i+1}`] = parseFloat(a.Amount) || 0;
      updatedRow[`CalculatedAllowance${i+1}`] = computed;
    } else {
      updatedRow[`Allowance${i+1}Name`] = "";
      updatedRow[`OriginalAllowance${i+1}`] = 0;
      updatedRow[`CalculatedAllowance${i+1}`] = 0;
    }
  }

  const effectiveDeductions = getEffectiveDeductions(deductions, selectedMonth, selectedYear);
  for (let i = 0; i < 10; i++) {
    const d = effectiveDeductions[i];
    if (d) {
      const computed = computeSingleDeduction(d, monthDays, paidDays, baseSalary);
      updatedRow[`Deduction${i+1}Name`] = deductionMasterList.find(m => String(m.Id) === String(d.F_DeductionMaster))?.Name || `Deduct_${d.F_DeductionMaster}`;
      updatedRow[`OriginalDeduction${i+1}`] = parseFloat(d.Amount) || 0;
      updatedRow[`CalculatedDeduction${i+1}`] = computed;
    } else {
      updatedRow[`Deduction${i+1}Name`] = "";
      updatedRow[`OriginalDeduction${i+1}`] = 0;
      updatedRow[`CalculatedDeduction${i+1}`] = 0;
    }
  }

  return updatedRow;
};
